// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectSessionSwitchMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_PFIX_TRADE_SESSION_SWITCH);
        this.SessionId = -1;
        this.TradeSessionStatusId = -1;
        this.ExchangeSessionName = null;
    }
}
